import { Card, CardContent } from "@/components/ui/card";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormCardActions } from "@/components/ui/form-card";
import { Input } from "@/components/ui/input";
import i18next from "i18next";
import { Control } from "react-hook-form";
import { useLocation } from "wouter";
import { z } from "zod";

export const formSchema = z.object({
  name: z.string().min(2, {
    message: i18next.t("ram:EnterAtLeastTwoCharacters"),
  }),
});

export type formSchemaType = z.infer<typeof formSchema>;

type GroupFormFieldsType = {
  isLoading: boolean;
  formControl: Control<formSchemaType>;
};

export function GroupFormFields({ isLoading, formControl }: GroupFormFieldsType) {
  const [_, navigate] = useLocation();

  return (
    <>
      <Card>
        <CardContent className="space-y-6">
          <FormField
            control={formControl}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{i18next.t("common:Name")}</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormDescription>{i18next.t("ram:NameOfTheGroup")}</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        </CardContent>
      </Card>

      <FormCardActions
        cancelLabel={i18next.t("common:Cancel")}
        onCancel={() => navigate("/")}
        isPending={isLoading}
        submitLabel={i18next.t("common:Save")}
      />
    </>
  );
}
